import axios, {type AxiosInstance} from "axios";
import Configuration from "../../Configuration.ts";
import type {SupportContext} from "../model/user/SupportContext.ts";

declare module "axios" {
    interface AxiosRequestConfig {
        /** Send without the support context, e.g. to search all garages while in one. */
        skipSupportContext?: boolean;
    }
}

export const SUPPORT_CONTEXT_HEADERS = {
    garage: "X-Garage-Context",
    group: "X-Garage-Group-Context",
} as const;

// Module-level state read by every request via interceptor.
// Replaces the previous pattern of mutating each service's
// defaults.headers and maintaining a manual serviceInstances array.
let currentToken: string | null = null;
let currentLanguage: string | null = null;
let currentSupportContext: SupportContext | null = null;

export const setAccessToken = (token: string): void => {
    currentToken = token;
};

export const setLanguageHeader = (language: string): void => {
    currentLanguage = language;
};

export const setSupportContextHeader = (context: SupportContext | null): void => {
    currentSupportContext = context;
};

export const createApi = (basePath: string): AxiosInstance => {
    const instance = axios.create({
        baseURL: Configuration.value("backendServer") + basePath,
    });
    instance.interceptors.request.use(config => {
        if (currentToken) {
            config.headers.Authorization = `Bearer ${currentToken}`;
        }
        if (currentLanguage) {
            config.headers["Accept-Language"] = currentLanguage;
        }
        if (currentSupportContext && !config.skipSupportContext) {
            config.headers[SUPPORT_CONTEXT_HEADERS[currentSupportContext.type]] = currentSupportContext.no;
        }
        return config;
    });
    return instance;
};
